var map = {
	"./author.svg": "7c25",
	"./calendar.svg": "b8bd",
	"./comments.svg": "12be",
	"./confirmed.svg": "5e4b",
	"./cross.svg": "2ad7",
	"./crown.svg": "07b0",
	"./denied.svg": "faf7",
	"./leaf.svg": "cdbd",
	"./presse.svg": "d972",
	"./upload.svg": "5a96"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";